import { useProcessRemittance } from 'api/action';
import { useListProvidersBySite, useListRemittanceBySite } from 'api/resource';
import { useState, useEffect } from 'react';
import { useCurrentSiteStore } from 'store/SiteStore';

export const useAdminRemittanceManagementData = () => {
  const { id: siteID } = useCurrentSiteStore();
  const [processingSubmission, setProcessingSubmission] =
    useState<boolean>(false);
  const remittanceResult = useListRemittanceBySite({ siteID });

  const processRemittance = useProcessRemittance();
  const siteProviders = useListProvidersBySite({ siteID });
  useEffect(() => {
    if (processRemittance.isPending) {
      setProcessingSubmission(true);
    }
    if (processRemittance.isSuccess) {
      remittanceResult.refetch();
      setProcessingSubmission(false);
    }
  }, [processRemittance?.status]);
  const isLoading = remittanceResult.isLoading;
  const isError = remittanceResult.isError;
  const isFetching = remittanceResult.isFetching || processingSubmission;
  const errorMessage = remittanceResult.error?.message;

  return {
    remittances: remittanceResult.data || [],
    siteProviders: siteProviders.data || [],
    isLoading,
    isError,
    isFetching,
    errorMessage,
    processRemittance,
  };
};
